export const ADDED_ITEM_ID_PREFIX = 'addedItem-';